export default __webpack_public_path__ + "static/media/fondoRazonTres.37b04f33.png";